import * as React from "react";
import { PageWrapper } from "./Styled";
import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube
} from "react-icons/fa";
import { FiArrowRight } from "react-icons/fi";
import Highlight from "../../Public/Highlight";
import { withRouter } from "react-router-dom";
import PasarCarousel from "../../Public/PasarCarousel";
import axios from "axios";
import { BASE_URL } from "../../Public/Util";
import ProductCategories from "./ProductsCategories";
import SocialIcon from "../../Public/SocialIcon";

const initialState = {
  data: []
};

class Pasar extends React.Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }
  callAPI = async () => {
    try {
      await axios.get(BASE_URL + "/api/productCategories").then(response => {
        const {
          data: {
            response: { productCategories }
          }
        } = response;
        this.setState({
          data: productCategories
        });

        const hash = this.props.location.hash;
        if (hash) {
          this.scrollToView(hash);
        }
      });
    } catch (e) {
      console.log(e);
    }
  };

  scrollToView = target => {
    target=target.replace(/[#\?]/g,'');;
    const targetScroll = document.getElementById(target).offsetTop;
    window.scrollTo(0, targetScroll);
  };

  componentDidMount() {
    this.callAPI();
  }

  componentDidUpdate = prevProps => {
    if (this.props.location.hash !== prevProps.location.hash) {
      // Hack: setTimeout delays click until end of current
      // event loop to ensure new screen has mounted.
      const hash = this.props.location.hash;
      if (hash) {
        this.scrollToView(hash);
      } else {
        window.scroll(0, 0);
      }
    }
  };

  render() {
    const { data } = this.state;
    return (
      <PageWrapper>
        <div className="header shorter">
          <div className="wrapper">
            <div className="header-text">
              <h3 className="sub-title">All on Boost Credit, just for you.</h3>
              <h1 className="title">
                Welcome to
                <br />
                Pasar
              </h1>
              <p className="content">
                Your one-stop solution for Micro-Financing and Micro-Insurance.
                <div className="social-icons">
                  Share to
                  <SocialIcon />
                </div>
              </p>
            </div>
          </div>
        </div>
        <Highlight />
        <ProductCategories data={data} />
      </PageWrapper>
    );
  }
}
export default withRouter(Pasar);
